export default __webpack_public_path__ + "static/media/product-selector-profile.77a3d858.png";